import { createContext, useContext, useState } from "react";

export const UA_ROLES = [
  { key: "LANDLORD", label: "Landlord" },
  { key: "AGENT",    label: "Agent" },
  { key: "TENANT",   label: "Tenant" },
];

const UltimateAgentContext = createContext();

export const UltimateAgentProvider = ({ children }) => {
  const [activeRole, setActiveRole] = useState("LANDLORD");
  return (
    <UltimateAgentContext.Provider value={{ activeRole, setActiveRole, UA_ROLES }}>
      {children}
    </UltimateAgentContext.Provider>
  );
};

export const useUltimateAgent = () => useContext(UltimateAgentContext);
